__webpack_require__.p = "https://world-web.sgp1.cdn.digitaloceanspaces.com/v4/";